<div class="notification-list-container">
  <!-- Header -->
  <div class="list-header">
    <h2 class="page-title">{{ 'notifications.title' | translate }}</h2>
    <p-button
      [label]="'notifications.markAllAsRead' | translate"
      icon="pi pi-check"
      [disabled]="!hasUnreadNotifications || loading"
      (onClick)="markAllAsRead()"
      styleClass="p-button-outlined"
    ></p-button>
  </div>

  <!-- Loading skeletons -->
  <div *ngIf="loading" class="skeleton-container">
    <p-card *ngFor="let item of skeletonArray" styleClass="notification-skeleton">
      <p-skeleton width="100%" height="1.5rem"></p-skeleton>
      <p-skeleton width="80%" height="1rem" styleClass="mt-2"></p-skeleton>
      <p-skeleton width="60%" height="0.875rem" styleClass="mt-2"></p-skeleton>
    </p-card>
  </div>

  <!-- Notification list -->
  <div *ngIf="!loading && notifications.length > 0" class="notifications-wrapper">
    <app-notification-page-item
      *ngFor="let notification of notifications"
      [notification]="notification"
    ></app-notification-page-item>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && notifications.length === 0" class="empty-state">
    <i class="pi pi-bell-slash empty-icon"></i>
    <h3 class="empty-title">{{ 'notifications.empty' | translate }}</h3>
  </div>

  <!-- Pagination -->
  <p-paginator
    *ngIf="!loading && notifications.length > 0"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [rowsPerPageOptions]="[10, 20, 50]"
    (onPageChange)="onPageChange($event)"
    styleClass="mt-4"
  ></p-paginator>
</div>
